var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlignCentericon = function SvgAlignCentericon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.222 9.778H8.778V8.222h3.11c.43 0 .779-.348.779-.778v-3.11a.778.778 0 0 0-.778-.778H8.778V2.389A.389.389 0 0 0 8.388 2h-.777a.389.389 0 0 0-.389.389v1.167h-3.11a.778.778 0 0 0-.779.777v3.111c0 .43.349.778.778.778h3.111v1.556H1.778a.778.778 0 0 0-.778.778v3.11c0 .43.348.778.778.778h5.444v1.167c0 .215.174.389.39.389h.777a.389.389 0 0 0 .389-.389v-1.167h5.444c.43 0 .778-.348.778-.777v-3.111a.778.778 0 0 0-.778-.778ZM4.89 6.667V5.11h6.222v1.556H4.89Zm-2.333 4.666v1.556h10.888v-1.556H2.556Z",
    clipRule: "evenodd"
  })));
};
export default SvgAlignCentericon;